import { toast } from 'react-toastify';
import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';
import { API_SYSTEM_ADMIN_QUESTION, API_SYSTEM_ADMIN_QUESTIONS, SYSTEM_ADMIN_PATH, TYPE_QUESTION } from '../../../../constants';
import {
     setCurrentTab,
     setIsLoading,
     setIsWaiting,
     setRemoveLoading,
     setShowEditPopup,
     setShowPopup,
     setShowRemovePopup,
} from '../../../../actions/general';
import { addAdminTests, updateAdminTest } from '../Tests/actions';
import { setAdminTestDetails } from '../Tests/Test/actions';
import {
     addAdminSurveyQuestion,
     deleteAdminQuestionUserSurveyResult,
     deleteAdminSurveyQuestion,
     setAdminSurveyDetails,
     setAdminSurveyQuestions,
} from '../Surveys/Survey/actions';

export const SET_ADMIN_QUESTION = 'setAdminQuestion';

export const setAdminQuestion = (question) => {
     return {
          type: SET_ADMIN_QUESTION,
          payload: question,
     };
};

export const fetchAdminQuestion = (questionId) => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SYSTEM_ADMIN_QUESTION.replace(':id', questionId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setAdminQuestion(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const addAdminQuestionRequest = (question, nextDispatch) => (dispatch, getState) => {
     const { addQuestion, navigate, id } = nextDispatch;
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_QUESTIONS, 'POST', question)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newQuestion = response.data;
               addQuestion(response.data);
               if (question.surveyId) {
                    const survey = getState().admin.surveyDetails;
                    const sections = survey?.surveySections;
                    const sectionName = sections?.find((sec) => sec.id === newQuestion.sectionId)?.name;

                    const newSurveyQuestion = {
                         ...newQuestion,
                         answers: [],
                         surveySection: {
                              name: sectionName,
                         },
                    };
                    dispatch(addAdminSurveyQuestion(newSurveyQuestion));
               }

               setTimeout(() => {
                    if (question.testId) {
                         navigate(SYSTEM_ADMIN_PATH.TEST_QUESTIONS_DETAIL.replace(':id', id).replace(':questionId', response.data.id));
                    } else if (question.surveyId && question.type !== TYPE_QUESTION.ASK_FOR_ANSWER) {
                         navigate(SYSTEM_ADMIN_PATH.SURVEY_QUESTIONS_DETAIL.replace(':id', id).replace(':questionId', response.data.id));
                    }
               }, 100);
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowPopup());
          });
};

export const updateAdminTestQuestion = (test) => (dispatch, getState) => {
     const testList = getState().admin.tests;

     if (!testList || !testList.length) {
          return;
     }

     dispatch(updateAdminTest(test));
};

export const updateAdminQuestion = (nextDispatch) => (dispatch, getState) => {
     const { newQuestion, question, testId } = nextDispatch;

     dispatch(setAdminQuestion({ ...question, ...newQuestion }));

     const testList = getState().admin.tests;

     if (!testList || !testList.length) {
          return;
     }

     const newTest = testList.find((test) => test.id === testId);

     if (!newTest) {
          return;
     }

     const newQuestions = newTest.questions.map((question) => {
          if (question.id === newQuestion.id) {
               return { ...question, ...newQuestion };
          }

          return question;
     });

     newTest.questions = newQuestions;

     dispatch(updateAdminTest(newTest));
};

export const updateAdminQuestionOrders = (questions, nextDispatch) => (dispatch, getState) => {
     const { test, setTest, survey, setQuestions } = nextDispatch;

     if (test) {
          const newTest = test;
          newTest.questions = questions;
          setTest(newTest);
          setQuestions(questions);

          const testList = getState().admin.test;

          if (!testList || !testList.length) {
               return;
          }

          const newTests = testList.map((item) => {
               if (item.id === newTest.id) {
                    const newTest = item;

                    newTest.questions = questions;
                    return { ...item, ...newTest };
               }

               return item;
          });

          dispatch(addAdminTests(newTests));
     } else if (survey) {
          dispatch(setAdminSurveyQuestions(questions));
          setQuestions(questions);
     }
};

export const updateAdminQuestionRequest = (questionId, question, handleUpdateQuestion) => (dispatch, getState) => {
     const surveyDetails = getState().admin.surveyDetails;
     const testDetails = getState().admin.testDetails;
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_QUESTION.replace(':id', questionId), 'PUT', question)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newQuestion = response.data;
               handleUpdateQuestion(newQuestion);

               if (newQuestion.testId) {
                    const newQuestions = testDetails.questions.map((ques) => {
                         if (ques.id === questionId) {
                              return { ...ques, ...newQuestion };
                         }
                         return ques;
                    });
                    const newTestDetails = {
                         ...testDetails,
                         questions: newQuestions,
                    };
                    dispatch(setAdminTestDetails(newTestDetails));
               }
               if (newQuestion.surveyId) {
                    const newQuestions = surveyDetails.questions.map((ques) => {
                         if (ques.id === questionId) {
                              return { ...ques, ...newQuestion };
                         }
                         return ques;
                    });
                    const newSurveyDetails = {
                         ...surveyDetails,
                         questions: newQuestions,
                    };
                    dispatch(setAdminSurveyDetails(newSurveyDetails));
               }

               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowEditPopup(null));
          });
};

export const deleteAdminQuestionRequest = (questionId, nextDispatch) => (dispatch, getState) => {
     const { navigate, id, isSurvey, handleUpdateTestQuestions } = nextDispatch;

     dispatch(setRemoveLoading(true));

     callApi(API_SYSTEM_ADMIN_QUESTION.replace(':id', questionId), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (isSurvey) {
                    dispatch(deleteAdminSurveyQuestion(questionId));
                    dispatch(deleteAdminQuestionUserSurveyResult(questionId));
               } else {
                    const testList = getState().admin.tests;

                    if (testList.length) {
                         const newTest = testList.find((test) => test.id === id);

                         if (newTest) {
                              const newQuestions = newTest.questions.filter((item) => item.id !== questionId);
                              newTest.questions = newQuestions;

                              if (handleUpdateTestQuestions) {
                                   handleUpdateTestQuestions(newTest);
                              }
                         }
                    }
               }

               if (navigate) {
                    if (isSurvey) {
                         navigate(SYSTEM_ADMIN_PATH.SURVEYS_DETAIL.replace(':id', id), { replace: true });
                    } else {
                         navigate(SYSTEM_ADMIN_PATH.TESTS_DETAIL.replace(':id', id), { replace: true });
                    }
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
               dispatch(setCurrentTab(null));
          });
};
